import styled, { createGlobalStyle } from "styled-components";
import SchneidlerLateinMedium from "./font/Schneidler-Latein-Medium.woff2";
import SchneidlerLateinRegular from "./font/Schneidler-Latein-Regular.woff2";

export const SchneidlerLateinMediumFont = createGlobalStyle`
@font-face {
  font-family: "SchneidlerLateinMedium";
  src: url(${SchneidlerLateinMedium}) format("woff2");
  font-style: normal;
  font-display: auto;
}
`;

export const SchneidlerLateinRegularFont = createGlobalStyle`
@font-face {
  font-family: "SchneidlerLateinRegular";
  src: url(${SchneidlerLateinRegular}) format("woff2");
  font-style: normal;
  font-display: auto;
}
`;

export const MainContainer = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  margin: auto;
  min-height: 100vh;
  background-color: #001369;
  justify-content: flex-start;
  .banner {
    width: 100%;
    height: 134px;
    object-fit: cover;
  }

  h1 {
    color: #fff;
    text-align: center;
    font-family: "SchneidlerLateinRegular";
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: 40px; /* 142.857% */
  }

  p {
    color: #fff;
    text-align: center;
    font-family: "SchneidlerLateinRegular";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: 0.5px;
  }
`;

export const Navbar = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 8px;
  padding: 16px 20px;
  border-bottom: 1px solid #000;
  background: #283495;
  img {
    height: 51px;
  }
  .balance-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }
  .balance-text {
    color: #fff;
    font-family: "SchneidlerLateinRegular";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 133.333% */
    letter-spacing: 0.15px;
  }
  .balance-value {
    color: #fff;
    font-family: "SchneidlerLateinMedium";
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.15px;
  }
`;

export const ContentContainer = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 24px 24px 0px;
  width: 100%;
  align-self: stretch;

  .highlight-text {
    color: #7fbbea;
  }
  a {
    font-weight: 500;
    font-family: "SchneidlerLateinMedium";
    text-decoration: underline;
    color: #fff;
  }
`;

export const LogosSection = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0px;
  background: #283495;
  img {
    height: 55px;
  }
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 16px;
  gap: 8px;

  img {
    height: 33px;
  }

  .powered-by {
    color: #fff;
    font-family: "Inter";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
  }

  .links-text {
    color: #fff;
    font-family: "Inter";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    letter-spacing: 0.5px;
  }
`;
